const WhatsAppSvg = () => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.54912 14.328C2.6173 12.7572 2.29097 10.9002 2.6314 9.10583C2.97184 7.31142 3.95563 5.70301 5.39803 4.58261C6.84044 3.46222 8.64224 2.90692 10.4651 3.02099C12.2879 3.13506 14.0065 3.91065 15.2979 5.20212C16.5894 6.49359 17.365 8.2121 17.4791 10.035C17.5932 11.8578 17.0379 13.6596 15.9175 15.102C14.7971 16.5444 13.1887 17.5282 11.3943 17.8687C9.59988 18.2091 7.74291 17.8828 6.17207 16.951L6.17209 16.9509L3.58174 17.691C3.47456 17.7216 3.36115 17.723 3.25326 17.6951C3.14536 17.6671 3.0469 17.6108 2.96809 17.532C2.88927 17.4532 2.83297 17.3547 2.80501 17.2468C2.77705 17.1389 2.77846 17.0255 2.80908 16.9184L3.54918 14.328L3.54912 14.328Z"
      stroke="currentColor"
      strokeWidth="0.9375"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.8839 14.875C11.0616 14.8762 10.2472 14.7151 9.48733 14.4009C8.72744 14.0868 8.03701 13.6258 7.45558 13.0444C6.87416 12.463 6.41318 11.7726 6.09906 11.0127C5.78493 10.2528 5.62384 9.43837 5.62501 8.61612C5.62687 8.03735 5.85821 7.48294 6.2683 7.07452C6.67839 6.6661 7.23373 6.43701 7.8125 6.4375C7.90743 6.4375 8.00068 6.4626 8.08278 6.51025C8.16489 6.55789 8.23294 6.6264 8.28004 6.70883L9.1934 8.30721C9.24849 8.4036 9.2769 8.51293 9.27572 8.62394C9.27454 8.73496 9.2438 8.84366 9.18668 8.93886L8.45316 10.1614C8.83054 10.9989 9.50113 11.6695 10.3386 12.0468L11.5611 11.3133C11.6563 11.2562 11.765 11.2255 11.8761 11.2243C11.9871 11.2231 12.0964 11.2515 12.1928 11.3066L13.7912 12.22C13.8736 12.2671 13.9421 12.3351 13.9898 12.4172C14.0374 12.4993 14.0625 12.5926 14.0625 12.6875C14.0608 13.2656 13.8311 13.8197 13.4231 14.2293C13.0151 14.639 12.462 14.871 11.8839 14.875Z"
      stroke="currentColor"
      strokeWidth="0.9375"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default WhatsAppSvg;
